import type {EditablePreview, PreviewPayload} from '../types'

export const convertPayloadToMap = (previews: PreviewPayload): Map<number, EditablePreview> => {
  const mappedPreviews: Array<[number, EditablePreview]> = Object.entries(previews).map(([id, preview]) => {
    const isDisabled = preview.isFullyCovered || preview.rulesets.length === 0
    return [
      Number(id),
      {
        ...preview,
        id: Number(id),
        isEnabled: preview.isEnabled ?? !isDisabled,
        isDisabled,
      },
    ]
  })
  return new Map(mappedPreviews)
}
